/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel, Configuration, BrowserSystemOptions } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
const systemOptions: BrowserSystemOptions = {
  loggerOptions: {
    loggerCallback: (level, message, containsPii) => {
      if (containsPii) {
        return;
      }
      switch (level) {
        case LogLevel.Error:
          console.error(message);
          return;
        case LogLevel.Info:
          console.info(message);
          return;
        case LogLevel.Verbose:
          console.debug(message);
          return;
        case LogLevel.Warning:
          console.warn(message);
          return;
      }
    },
  },
};

const baseConfig: Configuration = {
  auth: {
    clientId: '360bcd28-81b4-4c1e-afa4-a2fa8f154ca8', // This is the ONLY mandatory field that you need to supply.
    authority: 'https://login.microsoftonline.com/6258b5b1-bbcb-4a55-9c55-f103f863b950', // Defaults to "https://login.microsoftonline.com/common"
    redirectUri: '/', // Points to window.location.origin. You must register this URI on Azure Portal/App Registration.
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
  },
  cache: {
    cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

const makeConfig = () => {
  return {
    ...baseConfig,
    system: process.env.NODE_ENV === 'development' ? systemOptions : {},
  };
};

export const msalConfig = makeConfig();
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permi
 * };ssions-and-consent#openid-connect-scopes
 */

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */

export const protectedResources = {
  apiTodoList: {
    scopes: [],
  },
};

export const loginRequest = {
  scopes: ['api://3d0bd536-3c09-405e-a990-288874d56910/access_as_user'],
};

export const appRoles = {
  Electricity: 'AECP.Electricity',
  FTR: 'AECP.FTR',
  Alerts: 'AECP.Alerts',
  Gas: 'AECP.Gas',
  Broker: 'AECP.Broker',
  Datacore: 'AECP.Datacore',
  Match: 'AECP.Match',
};
